import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    transform(value: any, args?: any): any {
        if (!value || value === '') {
            return '';
        }

        const regex1 = /\d{2}.\d{2}.\d{4} \d{2}:\d{2}/;
        const regex2 = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}/;
        const regex3 = /\d{2}.\d{2}.\d{4} \d{2}:\d{2}:\d{2}/;
        const regex4 = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/;

        let formattedValue = value;

        if (value.match(regex3)) {
            formattedValue = moment(value, 'MM.DD.YYYY hh:mm:ss', false).format('YYYY-MM-DD HH:mm:ss');
        } else if (value.match(regex4)) {
            formattedValue = moment(value, 'YYYY-MM-DD hh:mm:ss', false).format('YYYY-MM-DD HH:mm:ss');
        } else if (value.match(regex1)) {
            formattedValue = moment(value, 'MM.DD.YYYY hh:mm', false).format('YYYY/MM/DD HH:mm');
        } else if (value.match(regex2)) {
            formattedValue = moment(value, 'YYYY-MM-DD hh:mm', false).format('YYYY/MM/DD HH:mm');
        }

        const m = moment.utc(formattedValue);
        return this.datePipe.transform(m.clone().local().format(), args);
    }
}


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/pipes/local-date.pipe.ts